import RequiredSign from "@components/common/ui-elements/required-sign";
import React from "react";
import {isPlainObject} from "@utils/object";
import {generateIdFromName, isNotStringOrEmptyString} from "@utils/string";
import {isDetailsMode, isEditableMode, useFormMode} from "@contexts/FormModeContext";
import {addUniqueCssClasses} from "@functions/css";

export default function ScrollableTextBoxBlock(
   {
      containerCssClass = 'col-12 py-3',
      dataBlock = '',
      required = false,
      value = '',
      onChange,
      helpText = '',
      controlId = '',
      controlName = '',
      inputAttrs = {},
      labelText = 'Control Label',
      disabled = false,
      readOnly = false,
      type = "text",
      inputCssClass = "form-control",
      asTextArea = false,
      labelCssClass = "",
      onKeyUp
   }
) {
   
   const {mode} = useFormMode();
   
   let paramError = '';
   
   
   // region [Container Css Class]
   
   if (typeof containerCssClass === 'string') {
      containerCssClass += ' scrollable';
   } else if (Array.isArray(containerCssClass)) {
      
      containerCssClass = (containerCssClass.join(' ')) + ' scrollable';
      
   } else {
      containerCssClass = 'scrollable';
   }
   
   if (isDetailsMode(mode)) {
      containerCssClass += ' details-mode';
   }
   
   // endregion
   
   // region [Control Name]
   
   if (typeof controlName !== 'string') {
      
      paramError = ("Control name for text box must be a string data type");
      
   } else if (controlName.trim() === '') {
      paramError = ("Control name for text box cannot be empty");
   }
   
   inputAttrs.name = controlName;
   
   // endregion
   
   // region [Control Attrs]
   
   if (!isPlainObject(inputAttrs)) {
      inputAttrs = {};
   }
   
   delete inputAttrs.name;
   
   // endregion
   
   // region [Label Text]
   
   if (typeof labelText !== 'string') {
      labelText = '';
   } else {
      labelText = labelText.trim();
   }
   
   // endregion
   
   // region [Data Block]
   
   if (typeof dataBlock !== 'string' || dataBlock.trim() === '') {
      dataBlock = controlName;
   }
   
   // endregion
   
   // region [Control ID]
   
   if (typeof controlId !== 'string' || controlId.trim() === '') {
      controlId = generateIdFromName(controlName);
   }
   
   // endregion
   
   // region [Input CSS class]
   
   if (isNotStringOrEmptyString(inputCssClass)) {
      inputCssClass = 'form-control';
   } else {
      inputCssClass += ' form-control';
   }
   
   // endregion
   
   if (undefined === value || null === value) {
      value = '';
   }
   
   labelCssClass = addUniqueCssClasses(labelCssClass, 'form-label');
   
   return (
      <div className={containerCssClass} data-block={dataBlock}>
         {labelText !== '' && (
            <label
               htmlFor={controlId}
               className={labelCssClass}
            >
               {labelText} <RequiredSign required={required} />
            </label>
         )}
         
         {isEditableMode(mode) && (
            <>
               {paramError !== '' && (
                  <p className="text-danger">{paramError}</p>
               )}
               
               {paramError === '' && (
                  
                  <div>
                     
                     {asTextArea === false && (
                        <input
                           type={type}
                           id={controlId}
                           name={controlName}
                           className={inputCssClass}
                           value={value}
                           required={required}
                           disabled={disabled}
                           readOnly={readOnly}
                           onChange={onChange}
                           {...inputAttrs}
                           onKeyUp={onKeyUp}
                        />
                     )}
                     
                     {asTextArea === true && (
                        <textarea
                           id={controlId}
                           name={controlName}
                           className={inputCssClass}
                           value={value}
                           required={required}
                           disabled={disabled}
                           readOnly={readOnly}
                           onChange={onChange}
                           {...inputAttrs}
                           onKeyUp={onKeyUp}
                        />
                     )}
                  
                  
                  </div>
               
               )}
               
               
               {helpText !== '' && (
                  <div className="form-text mt-2">
                     {helpText}
                  </div>
               )}
            </>
         )}
         
         {isDetailsMode(mode) && (
            <>
               <div className="form-text">
                  {value || '-'}
               </div>
            </>
         )}
         
         
         {isEditableMode(mode) && process.env.NEXT_PUBLIC_DISPLAY_CONTROL_NAMES === "1" && (
            <div className="mt-3 d-flex flex-column gap-3" style={{width: 'fit-content'}}>
               
               <p className="m-0 p-3 text-danger badge bg-primary-subtle fs-6 text-break">
                  {controlName}
               </p>
               
               <p className="m-0 p-3 text-black badge bg-success-subtle fs-6 text-break">
                  {dataBlock}
               </p>
            
            </div>
         )}
      
      </div>
   );
   
}